/* The app's one plan progress bar: a 6px `--bg-sunken` track with an `--accent` fill, both on
 * `--radius-4px`. The fill's width is the caller's — an inline size, or an animated one.
 *
 * Promoted out of `PlanCard.module.css` on 4 November 2026, on its second consumer: the plan
 * library's client-plan row, whose own 2.5px bar in the plan's category ink was retired by the
 * owner for this one ("one golden standard for the whole app"). Where the bar stands, and how wide
 * its track runs, is the host's. */

.track {
  display: block;
  height: var(--space-6px);
  overflow: hidden;
  background: var(--bg-sunken);
  border-radius: var(--radius-4px);
}

.fill {
  display: block;
  height: 100%;
  background: var(--accent);
  border-radius: var(--radius-4px);
}
